import axios from 'axios'
import Message from 'element-ui/lib/message'
import MessageBox from 'element-ui/lib/message-box'
import Loading from 'element-ui/lib/loading'
import store from '../store'
import { getToken, removeToken } from '@/utils/auth'

function stripVueInstances(obj) {
  if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return obj
  if (obj._isVue) return undefined
  var clean = {}
  Object.keys(obj).forEach(function(k) {
    var v = obj[k]
    if (v && typeof v === 'object' && v._isVue) return
    clean[k] = v
  })
  return clean
}

axios.interceptors.request.use(function(config) {
  if (config.params) config.params = stripVueInstances(config.params)
  return config
})

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API , // api的base_url
  timeout: 50000, // 请求超时时间,
})
//loading对象
let loading;
//当前正在请求的数量
let needLoadingRequestCount = 0;
//显示loading
function showLoading(target) {
  // 后面这个判断很重要，因为关闭时加了抖动，此时loading对象可能还存在，
  // 但needLoadingRequestCount已经变成0.避免这种情况下会重新创建个loading
  if (needLoadingRequestCount === 0 && !loading) {
    loading = Loading.service({
      lock: true,
      text: "正在加载中....",
      background: 'rgba(31, 31, 31, 0.5)',
      target: target || "body"
    });
  }
  needLoadingRequestCount++;
}

//隐藏loading
function hideLoading() {
  needLoadingRequestCount--;
  needLoadingRequestCount = Math.max(needLoadingRequestCount, 0); //做个保护
  if (needLoadingRequestCount === 0) {
    //关闭loading
    toHideLoading();
  }
}
//防抖：将 300ms 间隔内的关闭 loading 便合并为一次。防止连续请求时， loading闪烁的问题。
function debounce(fn, wait) {
  var timer = null;
  return function () {
    if (timer !== null) {
      clearTimeout(timer);
    }
    timer = setTimeout(fn, wait);
  }
}
var toHideLoading = debounce(() => {
  if (loading) {
    loading.close();
    loading = null;
  }

}, 300);

// request拦截器
service.interceptors.request.use(config => {
//  setTimeout(()=>{
  showLoading()
//  },100)

  config.headers['tenantId'] = store.getters.tenantid

  if (store.getters.token) {
    config.headers['X-Token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }

  if (store.getters.isIdentityAuth) {
    config.headers['Authorization'] = 'Bearer ' + store.getters.oidcAccessToken
  }

  // 获取URL地址
  const url = new URL(window.location.href).href;
  // 定义一个正则表达式，用于匹配URL中的数字部分
  const regex = /\/(\d+)$/;
  // 使用正则表达式匹配并提取数字部分
  const match = url.match(regex);
  let extractedNumber = ''
  if (match) {
    // match[1] 包含匹配到的数字部分
    extractedNumber = match[1];
    // console.log(extractedNumber); // 输出：460081591267397
  } else {
    // console.log('未找到匹配的数字');
  }
  if (config.data && !Array.isArray(config.data) && typeof config.data === 'object' && !config.data._isVue) {
    config.data = {
      ...config.data,
      formId: extractedNumber,
    }
  }
  if (config.params) config.params = stripVueInstances(config.params)


  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
    * code为非200是抛错 可结合自己业务进行修改
    */
    const res = response.data
 
    if (res.code !== 200) {
     
      // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        MessageBox.confirm('登录已超时，可以【取消】继续留在该页面，或者【重新登录】', '超时提醒', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload()// 为了重新实例化vue-router对象 避免bug
          })
          hideLoading();
        })
      } else {

        Message({
          message: res.message || res.msg,
          type: 'warning',
          duration: 2 * 1000
        })
        hideLoading();
      }

      return Promise.reject('error')
    } else {
      hideLoading();
      return response.data
    }
  },
  error => {

    if (error.response && error.response.status == 400) {  //调用远程服务时，前端类型和后端不匹配

      var message = '<strong>' + error.response.data.detail + '</strong><br>'
      //异常信息需要特殊处理一下
      var errors = Object.entries(error.response.data.errors).map(([key, value]) => ({ key, value }));
      errors.forEach(item => {
        message += item.key + ":"

        item.value.forEach(dtl => {
          message += " " + dtl;
        })

        message += "<br>";
      })
      Message({
        dangerouslyUseHTMLString: true,
        message: message,
        type: 'error',
        duration: 10 * 1000
      })
      hideLoading();
    } else {
      hideLoading();
    }

    if (error.response && error.response.status == 401) {
      // 只清 token，不硬刷新 — 让错误沿 Promise 链冒泡到路由守卫处理
      console.error('[request] 401 认证失败:', error.response.config.url,
        '| X-Token:', error.response.config.headers['X-Token'] || '(空)')
      removeToken()
    }
    hideLoading();
    return Promise.reject(error)
  }
)

export default service
